import React from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import Tick from './images/Tick';
import device from '../utils/device';

const Container = styled.div`
  background: ${({ theme }) => theme.colors.textLight};
  position: relative;

  padding: 1.96rem 1rem;
  margin: 4rem 0 3rem 0;

  @media ${device.desktop} {
    width: 32rem;
    padding: 2.5rem 2.1rem;
    margin: 0;
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.textDark};
  font-weigth: 700;

  font-size: 1.6rem;

  @media ${device.desktop} {
    font-size: 2.5rem;
  }
`;

const SubTitle = styled.div`
  color: ${({ theme }) => theme.colors.textDark};

  margin-top: 0.5rem;
  font-size: 1rem;
  font-weight: 300;

  .price {
    color: #f26c4f;
    font-weight: 700;
  }

  .was {
    text-decoration: line-through;
  }

  @media ${device.desktop} {
    font-size: 1.7rem;
  }
`;

const BenefitContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;

  @media ${device.desktop} {
    margin-top: 2rem;
    margin-bottom: 1.5rem;
  }
`;

const Benefit = styled.div`
  color: ${({ theme }) => theme.colors.textDark};
  display: flex;
  justify-content: space-between;

  font-size: 1rem;
  padding: 1rem 0;

  :not(:last-of-type) {
    border-bottom: 1px solid #ede1d3;
  }

  svg {
    height: 1rem;
  }

  @media ${device.desktop} {
    font-size: 1.2rem;
    padding: 1.2rem 1.2rem 1.2rem 0;

    svg {
      height: 1.2rem;
    }
  }
`;

const AlternateCurrencyContainer = styled.div`
  display: flex;

  margin-top: 2rem;

  @media ${device.desktop} {
    margin-top: 1.6rem;
  }
`;

const BuyAlternateCurrency = styled.a`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.actionSecondary};
  display: block;
  text-align: center;
  text-decoration: none;

  width: 50%;
  font-size: 1rem;
  padding: 0.5rem 0;

  .price {
    color: #1e1a1a;
  }

  :not(:last-of-type) {
    border-right: 2px solid #ede1d3;
  }

  @media ${device.desktop} {
    font-size: 1.25rem;
    padding: 1rem 0;
  }
`;

const Discount = styled.div`
  position: absolute;
  top: -3rem;
  right: -1rem;

  background: ${({ theme }) => theme.colors.actionPrimaryLight};
  color: ${({ theme }) => theme.colors.textLight};

  font-weight: 700;
  text-transform: uppercase;

  font-size: 0.73rem;
  padding: 1rem 0.5rem;

  .percent {
    display: block;
    text-align: center;
    font-size: 1.19rem;
    margin-bottom: 0.5rem;
  }

  @media ${device.desktop} {
    font-size: 1.1rem;
    padding: 1.1rem 0.6rem;

    top: -2rem;
    right: 2rem;

    .percent {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
    }
  }
`;

const PaymentBox = ({
  title,
  subTitle,
  discount,
  benefit,
  wasUsd,
  priceUsd,
  priceEuro,
  priceGbp,
  codeUsd,
  codeEuro,
  codeGbp,
  best,
}) => {
  return (
    <Container>
      <Title>{title}</Title>
      <SubTitle>
        {subTitle} {wasUsd && <span className="was">${wasUsd}</span>}{' '}
        <span className="price">${priceUsd}</span>
      </SubTitle>
      <Discount>
        <span className="percent">{discount}%</span>discount
      </Discount>
      <BenefitContainer>
        <Benefit>
          <div>{benefit}</div>
          <Tick />
        </Benefit>
        <Benefit>
          <div>14-day money back guarantee</div>
          <Tick />
        </Benefit>
      </BenefitContainer>
      <Button
        to={`https://alexhoward.teachable.com/purchase?product_id=${codeUsd}`}
        target="_blank"
        rel="noreferrer"
        fluid
        variant={best ? 'solid' : 'outline'}
      >
        Add to cart
      </Button>
      <AlternateCurrencyContainer>
        <BuyAlternateCurrency
          to={`https://alexhoward.teachable.com/purchase?product_id=${codeGbp}`}
          target="_blank"
          rel="noreferrer"
        >
          <span className="price">&pound;{priceGbp}</span> Pay in GBP
        </BuyAlternateCurrency>
        <BuyAlternateCurrency
          to={`https://alexhoward.teachable.com/purchase?product_id=${codeGbp}`}
          target="_blank"
          rel="noreferrer"
        >
          <span className="price">&euro;{priceEuro}</span> Pay in EUR
        </BuyAlternateCurrency>
      </AlternateCurrencyContainer>
    </Container>
  );
};

export default PaymentBox;
